export const AboutPillarPiece = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => (
  <article className="panel-surface border-b-8 border-cmj-red p-6">
    <h2 className="font-display text-3xl uppercase text-white">
      {title}
    </h2>
    <p className="mt-4 text-base leading-7 text-cmj-mist">{description}</p>
  </article>
);

export const WorkflowStepPiece = ({ step, index }: { step: string; index: number }) => (
  <div className="flex gap-4 rounded-md border border-white/10 bg-white/5 p-5">
    <span className="font-display text-4xl uppercase text-cmj-gold">
      {String(index + 1).padStart(2, "0")}
    </span>
    <p className="pt-1 text-base leading-7 text-cmj-white">{step}</p>
  </div>
);
